import gql from 'graphql-tag';
import * as ApolloReactCommon from '@apollo/react-common';
import * as ApolloReactHooks from '@apollo/react-hooks';
export type Maybe<T> = T | null;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
};

export type OptionEvaluation = {
   __typename?: 'OptionEvaluation';
  id: Scalars['String'];
  optionId: Scalars['String'];
  kind: Scalars['String'];
  itemId: Scalars['String'];
  value?: Maybe<Scalars['Float']>;
  description?: Maybe<Scalars['String']>;
};

export type Option = {
   __typename?: 'Option';
  createdAt?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  evaluation?: Maybe<Scalars['String']>;
  comments?: Maybe<Scalars['String']>;
  stakefactorsEvaluations?: Maybe<Array<Maybe<OptionEvaluation>>>;
  indicatorsEvaluations?: Maybe<Array<Maybe<OptionEvaluation>>>;
  constraintsEvaluations?: Maybe<Array<Maybe<OptionEvaluation>>>;
  isGutDecision?: Maybe<Scalars['Boolean']>;
};

export type Indicator = {
   __typename?: 'Indicator';
  createdAt?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  weight?: Maybe<Scalars['Int']>;
};

export type Constraint = {
   __typename?: 'Constraint';
  createdAt?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  weight?: Maybe<Scalars['Int']>;
};

export type Stakefactor = {
   __typename?: 'Stakefactor';
  createdAt?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  weight?: Maybe<Scalars['Int']>;
};

export type Project = {
   __typename?: 'Project';
  createdAt?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  context?: Maybe<Scalars['String']>;
  options?: Maybe<Array<Maybe<Option>>>;
  stakefactors?: Maybe<Array<Maybe<Stakefactor>>>;
  indicators?: Maybe<Array<Maybe<Indicator>>>;
  constraints?: Maybe<Array<Maybe<Constraint>>>;
  experienceLevel?: Maybe<Scalars['Int']>;
};

export type ProjectConnection = {
   __typename?: 'ProjectConnection';
  items?: Maybe<Array<Maybe<Project>>>;
  nextToken?: Maybe<Scalars['String']>;
};

export type Mutation = {
   __typename?: 'Mutation';
  createProject?: Maybe<Project>;
  updateProject?: Maybe<Project>;
  cloneProject?: Maybe<Scalars['Boolean']>;
  deleteProject?: Maybe<Scalars['Boolean']>;
  createOption?: Maybe<Option>;
  updateOption?: Maybe<Option>;
  deleteOption?: Maybe<Scalars['Boolean']>;
  createStakefactor?: Maybe<Stakefactor>;
  updateStakefactor?: Maybe<Stakefactor>;
  deleteStakefactor?: Maybe<Scalars['Boolean']>;
  createIndicator?: Maybe<Indicator>;
  updateIndicator?: Maybe<Indicator>;
  deleteIndicator?: Maybe<Scalars['Boolean']>;
  createConstraint?: Maybe<Constraint>;
  updateConstraint?: Maybe<Constraint>;
  deleteConstraint?: Maybe<Scalars['Boolean']>;
  updateOptionEvaluation?: Maybe<OptionEvaluation>;
};


export type MutationCreateProjectArgs = {
  description?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  context?: Maybe<Scalars['String']>;
  experienceLevel?: Maybe<Scalars['Int']>;
};


export type MutationUpdateProjectArgs = {
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  context?: Maybe<Scalars['String']>;
  experienceLevel?: Maybe<Scalars['Int']>;
};


export type MutationCloneProjectArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteProjectArgs = {
  id: Scalars['ID'];
};


export type MutationCreateOptionArgs = {
  description?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  comments?: Maybe<Scalars['String']>;
  projectId: Scalars['String'];
  evaluation?: Maybe<Scalars['String']>;
};


export type MutationUpdateOptionArgs = {
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  comments?: Maybe<Scalars['String']>;
  isGutDecision?: Maybe<Scalars['Boolean']>;
  evaluation?: Maybe<Scalars['String']>;
};


export type MutationDeleteOptionArgs = {
  id: Scalars['ID'];
};


export type MutationCreateStakefactorArgs = {
  description?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  weight?: Maybe<Scalars['Int']>;
  projectId: Scalars['String'];
};


export type MutationUpdateStakefactorArgs = {
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  weight?: Maybe<Scalars['Int']>;
};


export type MutationDeleteStakefactorArgs = {
  id: Scalars['ID'];
};


export type MutationCreateIndicatorArgs = {
  description?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  weight?: Maybe<Scalars['Int']>;
  projectId: Scalars['String'];
};


export type MutationUpdateIndicatorArgs = {
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  weight?: Maybe<Scalars['Int']>;
};


export type MutationDeleteIndicatorArgs = {
  id: Scalars['ID'];
};


export type MutationCreateConstraintArgs = {
  description?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  weight?: Maybe<Scalars['Int']>;
  projectId: Scalars['String'];
};


export type MutationUpdateConstraintArgs = {
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  weight?: Maybe<Scalars['Int']>;
};


export type MutationDeleteConstraintArgs = {
  id: Scalars['ID'];
};


export type MutationUpdateOptionEvaluationArgs = {
  optionId: Scalars['ID'];
  kind: Scalars['String'];
  itemId: Scalars['String'];
  value?: Maybe<Scalars['Float']>;
  description?: Maybe<Scalars['String']>;
};

export type Query = {
   __typename?: 'Query';
  getProject?: Maybe<Project>;
  listProjects?: Maybe<ProjectConnection>;
  queryProjectsByCreatedByIndex?: Maybe<ProjectConnection>;
};


export type QueryGetProjectArgs = {
  id: Scalars['ID'];
};


export type QueryListProjectsArgs = {
  filter?: Maybe<TableProjectFilterInput>;
  limit?: Maybe<Scalars['Int']>;
  nextToken?: Maybe<Scalars['String']>;
};


export type QueryQueryProjectsByCreatedByIndexArgs = {
  after?: Maybe<Scalars['String']>;
  createdBy: Scalars['String'];
  first?: Maybe<Scalars['Int']>;
};

export type OptionEvaluationInput = {
  itemId: Scalars['String'];
  value?: Maybe<Scalars['Float']>;
};

export type OptionEvaluationOutput = {
   __typename?: 'OptionEvaluationOutput';
  id: Scalars['String'];
  evaluations?: Maybe<Array<Maybe<OptionEvaluation>>>;
};

export type TableBooleanFilterInput = {
  eq?: Maybe<Scalars['Boolean']>;
  ne?: Maybe<Scalars['Boolean']>;
};

export type TableFloatFilterInput = {
  between?: Maybe<Array<Maybe<Scalars['Float']>>>;
  contains?: Maybe<Scalars['Float']>;
  eq?: Maybe<Scalars['Float']>;
  ge?: Maybe<Scalars['Float']>;
  gt?: Maybe<Scalars['Float']>;
  le?: Maybe<Scalars['Float']>;
  lt?: Maybe<Scalars['Float']>;
  ne?: Maybe<Scalars['Float']>;
  notContains?: Maybe<Scalars['Float']>;
};

export type TableIdFilterInput = {
  beginsWith?: Maybe<Scalars['ID']>;
  between?: Maybe<Array<Maybe<Scalars['ID']>>>;
  contains?: Maybe<Scalars['ID']>;
  eq?: Maybe<Scalars['ID']>;
  ge?: Maybe<Scalars['ID']>;
  gt?: Maybe<Scalars['ID']>;
  le?: Maybe<Scalars['ID']>;
  lt?: Maybe<Scalars['ID']>;
  ne?: Maybe<Scalars['ID']>;
  notContains?: Maybe<Scalars['ID']>;
};

export type TableIntFilterInput = {
  between?: Maybe<Array<Maybe<Scalars['Int']>>>;
  contains?: Maybe<Scalars['Int']>;
  eq?: Maybe<Scalars['Int']>;
  ge?: Maybe<Scalars['Int']>;
  gt?: Maybe<Scalars['Int']>;
  le?: Maybe<Scalars['Int']>;
  lt?: Maybe<Scalars['Int']>;
  ne?: Maybe<Scalars['Int']>;
  notContains?: Maybe<Scalars['Int']>;
};

export type TableProjectFilterInput = {
  createdAt?: Maybe<TableStringFilterInput>;
  createdBy?: Maybe<TableStringFilterInput>;
  description?: Maybe<TableStringFilterInput>;
  id?: Maybe<TableIdFilterInput>;
  name?: Maybe<TableStringFilterInput>;
};

export type TableStringFilterInput = {
  beginsWith?: Maybe<Scalars['String']>;
  between?: Maybe<Array<Maybe<Scalars['String']>>>;
  contains?: Maybe<Scalars['String']>;
  eq?: Maybe<Scalars['String']>;
  ge?: Maybe<Scalars['String']>;
  gt?: Maybe<Scalars['String']>;
  le?: Maybe<Scalars['String']>;
  lt?: Maybe<Scalars['String']>;
  ne?: Maybe<Scalars['String']>;
  notContains?: Maybe<Scalars['String']>;
};

export type GetProjectQueryVariables = {
  id: Scalars['ID'];
};


export type GetProjectQuery = (
  { __typename?: 'Query' }
  & { getProject?: Maybe<(
    { __typename?: 'Project' }
    & Pick<Project, 'context' | 'createdAt' | 'description' | 'experienceLevel' | 'id' | 'name'>
    & { constraints?: Maybe<Array<Maybe<(
      { __typename?: 'Constraint' }
      & Pick<Constraint, 'createdAt' | 'description' | 'id' | 'name' | 'weight'>
    )>>>, indicators?: Maybe<Array<Maybe<(
      { __typename?: 'Indicator' }
      & Pick<Indicator, 'createdAt' | 'description' | 'id' | 'name' | 'weight'>
    )>>>, options?: Maybe<Array<Maybe<(
      { __typename?: 'Option' }
      & Pick<Option, 'comments' | 'createdAt' | 'description' | 'evaluation' | 'id' | 'isGutDecision' | 'name'>
      & { constraintsEvaluations?: Maybe<Array<Maybe<(
        { __typename?: 'OptionEvaluation' }
        & Pick<OptionEvaluation, 'description' | 'id' | 'itemId' | 'kind' | 'optionId' | 'value'>
      )>>>, indicatorsEvaluations?: Maybe<Array<Maybe<(
        { __typename?: 'OptionEvaluation' }
        & Pick<OptionEvaluation, 'description' | 'id' | 'itemId' | 'kind' | 'optionId' | 'value'>
      )>>>, stakefactorsEvaluations?: Maybe<Array<Maybe<(
        { __typename?: 'OptionEvaluation' }
        & Pick<OptionEvaluation, 'description' | 'id' | 'itemId' | 'kind' | 'optionId' | 'value'>
      )>>> }
    )>>>, stakefactors?: Maybe<Array<Maybe<(
      { __typename?: 'Stakefactor' }
      & Pick<Stakefactor, 'createdAt' | 'description' | 'id' | 'name' | 'weight'>
    )>>> }
  )> }
);

export type ListProjectsQueryVariables = {
  filter?: Maybe<TableProjectFilterInput>;
  limit?: Maybe<Scalars['Int']>;
  nextToken?: Maybe<Scalars['String']>;
};


export type ListProjectsQuery = (
  { __typename?: 'Query' }
  & { listProjects?: Maybe<(
    { __typename?: 'ProjectConnection' }
    & Pick<ProjectConnection, 'nextToken'>
    & { items?: Maybe<Array<Maybe<(
      { __typename?: 'Project' }
      & Pick<Project, 'context' | 'createdAt' | 'description' | 'experienceLevel' | 'id' | 'name'>
      & { constraints?: Maybe<Array<Maybe<(
        { __typename?: 'Constraint' }
        & Pick<Constraint, 'createdAt' | 'description' | 'id' | 'name' | 'weight'>
      )>>>, indicators?: Maybe<Array<Maybe<(
        { __typename?: 'Indicator' }
        & Pick<Indicator, 'createdAt' | 'description' | 'id' | 'name' | 'weight'>
      )>>>, options?: Maybe<Array<Maybe<(
        { __typename?: 'Option' }
        & Pick<Option, 'comments' | 'createdAt' | 'description' | 'evaluation' | 'id' | 'isGutDecision' | 'name'>
        & { constraintsEvaluations?: Maybe<Array<Maybe<(
          { __typename?: 'OptionEvaluation' }
          & Pick<OptionEvaluation, 'description' | 'id' | 'itemId' | 'kind' | 'optionId' | 'value'>
        )>>>, indicatorsEvaluations?: Maybe<Array<Maybe<(
          { __typename?: 'OptionEvaluation' }
          & Pick<OptionEvaluation, 'description' | 'id' | 'itemId' | 'kind' | 'optionId' | 'value'>
        )>>>, stakefactorsEvaluations?: Maybe<Array<Maybe<(
          { __typename?: 'OptionEvaluation' }
          & Pick<OptionEvaluation, 'description' | 'id' | 'itemId' | 'kind' | 'optionId' | 'value'>
        )>>> }
      )>>>, stakefactors?: Maybe<Array<Maybe<(
        { __typename?: 'Stakefactor' }
        & Pick<Stakefactor, 'createdAt' | 'description' | 'id' | 'name' | 'weight'>
      )>>> }
    )>>> }
  )> }
);

export type QueryProjectsByCreatedByIndexQueryVariables = {
  after?: Maybe<Scalars['String']>;
  createdBy: Scalars['String'];
  first?: Maybe<Scalars['Int']>;
};


export type QueryProjectsByCreatedByIndexQuery = (
  { __typename?: 'Query' }
  & { queryProjectsByCreatedByIndex?: Maybe<(
    { __typename?: 'ProjectConnection' }
    & Pick<ProjectConnection, 'nextToken'>
    & { items?: Maybe<Array<Maybe<(
      { __typename?: 'Project' }
      & Pick<Project, 'context' | 'createdAt' | 'description' | 'experienceLevel' | 'id' | 'name'>
      & { constraints?: Maybe<Array<Maybe<(
        { __typename?: 'Constraint' }
        & Pick<Constraint, 'createdAt' | 'description' | 'id' | 'name' | 'weight'>
      )>>>, indicators?: Maybe<Array<Maybe<(
        { __typename?: 'Indicator' }
        & Pick<Indicator, 'createdAt' | 'description' | 'id' | 'name' | 'weight'>
      )>>>, options?: Maybe<Array<Maybe<(
        { __typename?: 'Option' }
        & Pick<Option, 'comments' | 'createdAt' | 'description' | 'evaluation' | 'id' | 'isGutDecision' | 'name'>
        & { constraintsEvaluations?: Maybe<Array<Maybe<(
          { __typename?: 'OptionEvaluation' }
          & Pick<OptionEvaluation, 'description' | 'id' | 'itemId' | 'kind' | 'optionId' | 'value'>
        )>>>, indicatorsEvaluations?: Maybe<Array<Maybe<(
          { __typename?: 'OptionEvaluation' }
          & Pick<OptionEvaluation, 'description' | 'id' | 'itemId' | 'kind' | 'optionId' | 'value'>
        )>>>, stakefactorsEvaluations?: Maybe<Array<Maybe<(
          { __typename?: 'OptionEvaluation' }
          & Pick<OptionEvaluation, 'description' | 'id' | 'itemId' | 'kind' | 'optionId' | 'value'>
        )>>> }
      )>>>, stakefactors?: Maybe<Array<Maybe<(
        { __typename?: 'Stakefactor' }
        & Pick<Stakefactor, 'createdAt' | 'description' | 'id' | 'name' | 'weight'>
      )>>> }
    )>>> }
  )> }
);

export type CloneProjectMutationVariables = {
  id: Scalars['ID'];
};


export type CloneProjectMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'cloneProject'>
);

export type CreateConstraintMutationVariables = {
  description?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  projectId: Scalars['String'];
  weight?: Maybe<Scalars['Int']>;
};


export type CreateConstraintMutation = (
  { __typename?: 'Mutation' }
  & { createConstraint?: Maybe<(
    { __typename?: 'Constraint' }
    & Pick<Constraint, 'createdAt' | 'description' | 'id' | 'name' | 'weight'>
  )> }
);

export type CreateIndicatorMutationVariables = {
  description?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  projectId: Scalars['String'];
  weight?: Maybe<Scalars['Int']>;
};


export type CreateIndicatorMutation = (
  { __typename?: 'Mutation' }
  & { createIndicator?: Maybe<(
    { __typename?: 'Indicator' }
    & Pick<Indicator, 'createdAt' | 'description' | 'id' | 'name' | 'weight'>
  )> }
);

export type CreateOptionMutationVariables = {
  comments?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  evaluation?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  projectId: Scalars['String'];
};


export type CreateOptionMutation = (
  { __typename?: 'Mutation' }
  & { createOption?: Maybe<(
    { __typename?: 'Option' }
    & Pick<Option, 'comments' | 'createdAt' | 'description' | 'evaluation' | 'id' | 'isGutDecision' | 'name'>
    & { constraintsEvaluations?: Maybe<Array<Maybe<(
      { __typename?: 'OptionEvaluation' }
      & Pick<OptionEvaluation, 'description' | 'id' | 'itemId' | 'kind' | 'optionId' | 'value'>
    )>>>, indicatorsEvaluations?: Maybe<Array<Maybe<(
      { __typename?: 'OptionEvaluation' }
      & Pick<OptionEvaluation, 'description' | 'id' | 'itemId' | 'kind' | 'optionId' | 'value'>
    )>>>, stakefactorsEvaluations?: Maybe<Array<Maybe<(
      { __typename?: 'OptionEvaluation' }
      & Pick<OptionEvaluation, 'description' | 'id' | 'itemId' | 'kind' | 'optionId' | 'value'>
    )>>> }
  )> }
);

export type CreateProjectMutationVariables = {
  context?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  experienceLevel?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
};


export type CreateProjectMutation = (
  { __typename?: 'Mutation' }
  & { createProject?: Maybe<(
    { __typename?: 'Project' }
    & Pick<Project, 'context' | 'createdAt' | 'description' | 'experienceLevel' | 'id' | 'name'>
    & { constraints?: Maybe<Array<Maybe<(
      { __typename?: 'Constraint' }
      & Pick<Constraint, 'createdAt' | 'description' | 'id' | 'name' | 'weight'>
    )>>>, indicators?: Maybe<Array<Maybe<(
      { __typename?: 'Indicator' }
      & Pick<Indicator, 'createdAt' | 'description' | 'id' | 'name' | 'weight'>
    )>>>, options?: Maybe<Array<Maybe<(
      { __typename?: 'Option' }
      & Pick<Option, 'comments' | 'createdAt' | 'description' | 'evaluation' | 'id' | 'isGutDecision' | 'name'>
      & { constraintsEvaluations?: Maybe<Array<Maybe<(
        { __typename?: 'OptionEvaluation' }
        & Pick<OptionEvaluation, 'description' | 'id' | 'itemId' | 'kind' | 'optionId' | 'value'>
      )>>>, indicatorsEvaluations?: Maybe<Array<Maybe<(
        { __typename?: 'OptionEvaluation' }
        & Pick<OptionEvaluation, 'description' | 'id' | 'itemId' | 'kind' | 'optionId' | 'value'>
      )>>>, stakefactorsEvaluations?: Maybe<Array<Maybe<(
        { __typename?: 'OptionEvaluation' }
        & Pick<OptionEvaluation, 'description' | 'id' | 'itemId' | 'kind' | 'optionId' | 'value'>
      )>>> }
    )>>>, stakefactors?: Maybe<Array<Maybe<(
      { __typename?: 'Stakefactor' }
      & Pick<Stakefactor, 'createdAt' | 'description' | 'id' | 'name' | 'weight'>
    )>>> }
  )> }
);

export type CreateStakefactorMutationVariables = {
  description?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  projectId: Scalars['String'];
  weight?: Maybe<Scalars['Int']>;
};


export type CreateStakefactorMutation = (
  { __typename?: 'Mutation' }
  & { createStakefactor?: Maybe<(
    { __typename?: 'Stakefactor' }
    & Pick<Stakefactor, 'createdAt' | 'description' | 'id' | 'name' | 'weight'>
  )> }
);

export type DeleteConstraintMutationVariables = {
  id: Scalars['ID'];
};


export type DeleteConstraintMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'deleteConstraint'>
);

export type DeleteIndicatorMutationVariables = {
  id: Scalars['ID'];
};


export type DeleteIndicatorMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'deleteIndicator'>
);

export type DeleteOptionMutationVariables = {
  id: Scalars['ID'];
};


export type DeleteOptionMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'deleteOption'>
);

export type DeleteProjectMutationVariables = {
  id: Scalars['ID'];
};


export type DeleteProjectMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'deleteProject'>
);

export type DeleteStakefactorMutationVariables = {
  id: Scalars['ID'];
};


export type DeleteStakefactorMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'deleteStakefactor'>
);

export type UpdateConstraintMutationVariables = {
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  weight?: Maybe<Scalars['Int']>;
};


export type UpdateConstraintMutation = (
  { __typename?: 'Mutation' }
  & { updateConstraint?: Maybe<(
    { __typename?: 'Constraint' }
    & Pick<Constraint, 'createdAt' | 'description' | 'id' | 'name' | 'weight'>
  )> }
);

export type UpdateIndicatorMutationVariables = {
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  weight?: Maybe<Scalars['Int']>;
};


export type UpdateIndicatorMutation = (
  { __typename?: 'Mutation' }
  & { updateIndicator?: Maybe<(
    { __typename?: 'Indicator' }
    & Pick<Indicator, 'createdAt' | 'description' | 'id' | 'name' | 'weight'>
  )> }
);

export type UpdateOptionMutationVariables = {
  comments?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  evaluation?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isGutDecision?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
};


export type UpdateOptionMutation = (
  { __typename?: 'Mutation' }
  & { updateOption?: Maybe<(
    { __typename?: 'Option' }
    & Pick<Option, 'comments' | 'createdAt' | 'description' | 'evaluation' | 'id' | 'isGutDecision' | 'name'>
    & { constraintsEvaluations?: Maybe<Array<Maybe<(
      { __typename?: 'OptionEvaluation' }
      & Pick<OptionEvaluation, 'description' | 'id' | 'itemId' | 'kind' | 'optionId' | 'value'>
    )>>>, indicatorsEvaluations?: Maybe<Array<Maybe<(
      { __typename?: 'OptionEvaluation' }
      & Pick<OptionEvaluation, 'description' | 'id' | 'itemId' | 'kind' | 'optionId' | 'value'>
    )>>>, stakefactorsEvaluations?: Maybe<Array<Maybe<(
      { __typename?: 'OptionEvaluation' }
      & Pick<OptionEvaluation, 'description' | 'id' | 'itemId' | 'kind' | 'optionId' | 'value'>
    )>>> }
  )> }
);

export type UpdateOptionEvaluationMutationVariables = {
  description?: Maybe<Scalars['String']>;
  itemId: Scalars['String'];
  kind: Scalars['String'];
  optionId: Scalars['ID'];
  value?: Maybe<Scalars['Float']>;
};


export type UpdateOptionEvaluationMutation = (
  { __typename?: 'Mutation' }
  & { updateOptionEvaluation?: Maybe<(
    { __typename?: 'OptionEvaluation' }
    & Pick<OptionEvaluation, 'description' | 'id' | 'itemId' | 'kind' | 'optionId' | 'value'>
  )> }
);

export type UpdateProjectMutationVariables = {
  context?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  experienceLevel?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
};


export type UpdateProjectMutation = (
  { __typename?: 'Mutation' }
  & { updateProject?: Maybe<(
    { __typename?: 'Project' }
    & Pick<Project, 'context' | 'createdAt' | 'description' | 'experienceLevel' | 'id' | 'name'>
    & { constraints?: Maybe<Array<Maybe<(
      { __typename?: 'Constraint' }
      & Pick<Constraint, 'createdAt' | 'description' | 'id' | 'name' | 'weight'>
    )>>>, indicators?: Maybe<Array<Maybe<(
      { __typename?: 'Indicator' }
      & Pick<Indicator, 'createdAt' | 'description' | 'id' | 'name' | 'weight'>
    )>>>, options?: Maybe<Array<Maybe<(
      { __typename?: 'Option' }
      & Pick<Option, 'comments' | 'createdAt' | 'description' | 'evaluation' | 'id' | 'isGutDecision' | 'name'>
      & { constraintsEvaluations?: Maybe<Array<Maybe<(
        { __typename?: 'OptionEvaluation' }
        & Pick<OptionEvaluation, 'description' | 'id' | 'itemId' | 'kind' | 'optionId' | 'value'>
      )>>>, indicatorsEvaluations?: Maybe<Array<Maybe<(
        { __typename?: 'OptionEvaluation' }
        & Pick<OptionEvaluation, 'description' | 'id' | 'itemId' | 'kind' | 'optionId' | 'value'>
      )>>>, stakefactorsEvaluations?: Maybe<Array<Maybe<(
        { __typename?: 'OptionEvaluation' }
        & Pick<OptionEvaluation, 'description' | 'id' | 'itemId' | 'kind' | 'optionId' | 'value'>
      )>>> }
    )>>>, stakefactors?: Maybe<Array<Maybe<(
      { __typename?: 'Stakefactor' }
      & Pick<Stakefactor, 'createdAt' | 'description' | 'id' | 'name' | 'weight'>
    )>>> }
  )> }
);

export type UpdateStakefactorMutationVariables = {
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  weight?: Maybe<Scalars['Int']>;
};


export type UpdateStakefactorMutation = (
  { __typename?: 'Mutation' }
  & { updateStakefactor?: Maybe<(
    { __typename?: 'Stakefactor' }
    & Pick<Stakefactor, 'createdAt' | 'description' | 'id' | 'name' | 'weight'>
  )> }
);


export const GetProjectDocument = gql`
    query GetProject($id: ID!) {
  getProject(id: $id) {
    constraints {
      createdAt
      description
      id
      name
      weight
    }
    context
    createdAt
    description
    experienceLevel
    id
    indicators {
      createdAt
      description
      id
      name
      weight
    }
    name
    options {
      comments
      constraintsEvaluations {
        description
        id
        itemId
        kind
        optionId
        value
      }
      createdAt
      description
      evaluation
      id
      indicatorsEvaluations {
        description
        id
        itemId
        kind
        optionId
        value
      }
      isGutDecision
      name
      stakefactorsEvaluations {
        description
        id
        itemId
        kind
        optionId
        value
      }
    }
    stakefactors {
      createdAt
      description
      id
      name
      weight
    }
  }
}
    `;

/**
 * __useGetProjectQuery__
 *
 * To run a query within a React component, call `useGetProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetProjectQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetProjectQuery, GetProjectQueryVariables>) {
        return ApolloReactHooks.useQuery<GetProjectQuery, GetProjectQueryVariables>(GetProjectDocument, baseOptions);
      }
export function useGetProjectLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetProjectQuery, GetProjectQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetProjectQuery, GetProjectQueryVariables>(GetProjectDocument, baseOptions);
        }
export type GetProjectQueryHookResult = ReturnType<typeof useGetProjectQuery>;
export type GetProjectLazyQueryHookResult = ReturnType<typeof useGetProjectLazyQuery>;
export type GetProjectQueryResult = ApolloReactCommon.QueryResult<GetProjectQuery, GetProjectQueryVariables>;
export const ListProjectsDocument = gql`
    query ListProjects($filter: TableProjectFilterInput, $limit: Int, $nextToken: String) {
  listProjects(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      constraints {
        createdAt
        description
        id
        name
        weight
      }
      context
      createdAt
      description
      experienceLevel
      id
      indicators {
        createdAt
        description
        id
        name
        weight
      }
      name
      options {
        comments
        constraintsEvaluations {
          description
          id
          itemId
          kind
          optionId
          value
        }
        createdAt
        description
        evaluation
        id
        indicatorsEvaluations {
          description
          id
          itemId
          kind
          optionId
          value
        }
        isGutDecision
        name
        stakefactorsEvaluations {
          description
          id
          itemId
          kind
          optionId
          value
        }
      }
      stakefactors {
        createdAt
        description
        id
        name
        weight
      }
    }
    nextToken
  }
}
    `;

/**
 * __useListProjectsQuery__
 *
 * To run a query within a React component, call `useListProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListProjectsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      limit: // value for 'limit'
 *      nextToken: // value for 'nextToken'
 *   },
 * });
 */
export function useListProjectsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ListProjectsQuery, ListProjectsQueryVariables>) {
        return ApolloReactHooks.useQuery<ListProjectsQuery, ListProjectsQueryVariables>(ListProjectsDocument, baseOptions);
      }
export function useListProjectsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ListProjectsQuery, ListProjectsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<ListProjectsQuery, ListProjectsQueryVariables>(ListProjectsDocument, baseOptions);
        }
export type ListProjectsQueryHookResult = ReturnType<typeof useListProjectsQuery>;
export type ListProjectsLazyQueryHookResult = ReturnType<typeof useListProjectsLazyQuery>;
export type ListProjectsQueryResult = ApolloReactCommon.QueryResult<ListProjectsQuery, ListProjectsQueryVariables>;
export const QueryProjectsByCreatedByIndexDocument = gql`
    query QueryProjectsByCreatedByIndex($after: String, $createdBy: String!, $first: Int) {
  queryProjectsByCreatedByIndex(after: $after, createdBy: $createdBy, first: $first) {
    items {
      constraints {
        createdAt
        description
        id
        name
        weight
      }
      context
      createdAt
      description
      experienceLevel
      id
      indicators {
        createdAt
        description
        id
        name
        weight
      }
      name
      options {
        comments
        constraintsEvaluations {
          description
          id
          itemId
          kind
          optionId
          value
        }
        createdAt
        description
        evaluation
        id
        indicatorsEvaluations {
          description
          id
          itemId
          kind
          optionId
          value
        }
        isGutDecision
        name
        stakefactorsEvaluations {
          description
          id
          itemId
          kind
          optionId
          value
        }
      }
      stakefactors {
        createdAt
        description
        id
        name
        weight
      }
    }
    nextToken
  }
}
    `;

/**
 * __useQueryProjectsByCreatedByIndexQuery__
 *
 * To run a query within a React component, call `useQueryProjectsByCreatedByIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryProjectsByCreatedByIndexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryProjectsByCreatedByIndexQuery({
 *   variables: {
 *      after: // value for 'after'
 *      createdBy: // value for 'createdBy'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useQueryProjectsByCreatedByIndexQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<QueryProjectsByCreatedByIndexQuery, QueryProjectsByCreatedByIndexQueryVariables>) {
        return ApolloReactHooks.useQuery<QueryProjectsByCreatedByIndexQuery, QueryProjectsByCreatedByIndexQueryVariables>(QueryProjectsByCreatedByIndexDocument, baseOptions);
      }
export function useQueryProjectsByCreatedByIndexLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<QueryProjectsByCreatedByIndexQuery, QueryProjectsByCreatedByIndexQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<QueryProjectsByCreatedByIndexQuery, QueryProjectsByCreatedByIndexQueryVariables>(QueryProjectsByCreatedByIndexDocument, baseOptions);
        }
export type QueryProjectsByCreatedByIndexQueryHookResult = ReturnType<typeof useQueryProjectsByCreatedByIndexQuery>;
export type QueryProjectsByCreatedByIndexLazyQueryHookResult = ReturnType<typeof useQueryProjectsByCreatedByIndexLazyQuery>;
export type QueryProjectsByCreatedByIndexQueryResult = ApolloReactCommon.QueryResult<QueryProjectsByCreatedByIndexQuery, QueryProjectsByCreatedByIndexQueryVariables>;
export const CloneProjectDocument = gql`
    mutation CloneProject($id: ID!) {
  cloneProject(id: $id)
}
    `;
export type CloneProjectMutationFn = ApolloReactCommon.MutationFunction<CloneProjectMutation, CloneProjectMutationVariables>;

/**
 * __useCloneProjectMutation__
 *
 * To run a mutation, you first call `useCloneProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloneProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cloneProjectMutation, { data, loading, error }] = useCloneProjectMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCloneProjectMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CloneProjectMutation, CloneProjectMutationVariables>) {
        return ApolloReactHooks.useMutation<CloneProjectMutation, CloneProjectMutationVariables>(CloneProjectDocument, baseOptions);
      }
export type CloneProjectMutationHookResult = ReturnType<typeof useCloneProjectMutation>;
export type CloneProjectMutationResult = ApolloReactCommon.MutationResult<CloneProjectMutation>;
export type CloneProjectMutationOptions = ApolloReactCommon.BaseMutationOptions<CloneProjectMutation, CloneProjectMutationVariables>;
export const CreateConstraintDocument = gql`
    mutation CreateConstraint($description: String, $name: String!, $projectId: String!, $weight: Int) {
  createConstraint(description: $description, name: $name, projectId: $projectId, weight: $weight) {
    createdAt
    description
    id
    name
    weight
  }
}
    `;
export type CreateConstraintMutationFn = ApolloReactCommon.MutationFunction<CreateConstraintMutation, CreateConstraintMutationVariables>;

/**
 * __useCreateConstraintMutation__
 *
 * To run a mutation, you first call `useCreateConstraintMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateConstraintMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createConstraintMutation, { data, loading, error }] = useCreateConstraintMutation({
 *   variables: {
 *      description: // value for 'description'
 *      name: // value for 'name'
 *      projectId: // value for 'projectId'
 *      weight: // value for 'weight'
 *   },
 * });
 */
export function useCreateConstraintMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateConstraintMutation, CreateConstraintMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateConstraintMutation, CreateConstraintMutationVariables>(CreateConstraintDocument, baseOptions);
      }
export type CreateConstraintMutationHookResult = ReturnType<typeof useCreateConstraintMutation>;
export type CreateConstraintMutationResult = ApolloReactCommon.MutationResult<CreateConstraintMutation>;
export type CreateConstraintMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateConstraintMutation, CreateConstraintMutationVariables>;
export const CreateIndicatorDocument = gql`
    mutation CreateIndicator($description: String, $name: String!, $projectId: String!, $weight: Int) {
  createIndicator(description: $description, name: $name, projectId: $projectId, weight: $weight) {
    createdAt
    description
    id
    name
    weight
  }
}
    `;
export type CreateIndicatorMutationFn = ApolloReactCommon.MutationFunction<CreateIndicatorMutation, CreateIndicatorMutationVariables>;

/**
 * __useCreateIndicatorMutation__
 *
 * To run a mutation, you first call `useCreateIndicatorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateIndicatorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createIndicatorMutation, { data, loading, error }] = useCreateIndicatorMutation({
 *   variables: {
 *      description: // value for 'description'
 *      name: // value for 'name'
 *      projectId: // value for 'projectId'
 *      weight: // value for 'weight'
 *   },
 * });
 */
export function useCreateIndicatorMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateIndicatorMutation, CreateIndicatorMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateIndicatorMutation, CreateIndicatorMutationVariables>(CreateIndicatorDocument, baseOptions);
      }
export type CreateIndicatorMutationHookResult = ReturnType<typeof useCreateIndicatorMutation>;
export type CreateIndicatorMutationResult = ApolloReactCommon.MutationResult<CreateIndicatorMutation>;
export type CreateIndicatorMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateIndicatorMutation, CreateIndicatorMutationVariables>;
export const CreateOptionDocument = gql`
    mutation CreateOption($comments: String, $description: String, $evaluation: String, $name: String!, $projectId: String!) {
  createOption(comments: $comments, description: $description, evaluation: $evaluation, name: $name, projectId: $projectId) {
    comments
    constraintsEvaluations {
      description
      id
      itemId
      kind
      optionId
      value
    }
    createdAt
    description
    evaluation
    id
    indicatorsEvaluations {
      description
      id
      itemId
      kind
      optionId
      value
    }
    isGutDecision
    name
    stakefactorsEvaluations {
      description
      id
      itemId
      kind
      optionId
      value
    }
  }
}
    `;
export type CreateOptionMutationFn = ApolloReactCommon.MutationFunction<CreateOptionMutation, CreateOptionMutationVariables>;

/**
 * __useCreateOptionMutation__
 *
 * To run a mutation, you first call `useCreateOptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOptionMutation, { data, loading, error }] = useCreateOptionMutation({
 *   variables: {
 *      comments: // value for 'comments'
 *      description: // value for 'description'
 *      evaluation: // value for 'evaluation'
 *      name: // value for 'name'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useCreateOptionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateOptionMutation, CreateOptionMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateOptionMutation, CreateOptionMutationVariables>(CreateOptionDocument, baseOptions);
      }
export type CreateOptionMutationHookResult = ReturnType<typeof useCreateOptionMutation>;
export type CreateOptionMutationResult = ApolloReactCommon.MutationResult<CreateOptionMutation>;
export type CreateOptionMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateOptionMutation, CreateOptionMutationVariables>;
export const CreateProjectDocument = gql`
    mutation CreateProject($context: String, $description: String, $experienceLevel: Int, $name: String!) {
  createProject(context: $context, description: $description, experienceLevel: $experienceLevel, name: $name) {
    constraints {
      createdAt
      description
      id
      name
      weight
    }
    context
    createdAt
    description
    experienceLevel
    id
    indicators {
      createdAt
      description
      id
      name
      weight
    }
    name
    options {
      comments
      constraintsEvaluations {
        description
        id
        itemId
        kind
        optionId
        value
      }
      createdAt
      description
      evaluation
      id
      indicatorsEvaluations {
        description
        id
        itemId
        kind
        optionId
        value
      }
      isGutDecision
      name
      stakefactorsEvaluations {
        description
        id
        itemId
        kind
        optionId
        value
      }
    }
    stakefactors {
      createdAt
      description
      id
      name
      weight
    }
  }
}
    `;
export type CreateProjectMutationFn = ApolloReactCommon.MutationFunction<CreateProjectMutation, CreateProjectMutationVariables>;

/**
 * __useCreateProjectMutation__
 *
 * To run a mutation, you first call `useCreateProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProjectMutation, { data, loading, error }] = useCreateProjectMutation({
 *   variables: {
 *      context: // value for 'context'
 *      description: // value for 'description'
 *      experienceLevel: // value for 'experienceLevel'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useCreateProjectMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateProjectMutation, CreateProjectMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateProjectMutation, CreateProjectMutationVariables>(CreateProjectDocument, baseOptions);
      }
export type CreateProjectMutationHookResult = ReturnType<typeof useCreateProjectMutation>;
export type CreateProjectMutationResult = ApolloReactCommon.MutationResult<CreateProjectMutation>;
export type CreateProjectMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateProjectMutation, CreateProjectMutationVariables>;
export const CreateStakefactorDocument = gql`
    mutation CreateStakefactor($description: String, $name: String!, $projectId: String!, $weight: Int) {
  createStakefactor(description: $description, name: $name, projectId: $projectId, weight: $weight) {
    createdAt
    description
    id
    name
    weight
  }
}
    `;
export type CreateStakefactorMutationFn = ApolloReactCommon.MutationFunction<CreateStakefactorMutation, CreateStakefactorMutationVariables>;

/**
 * __useCreateStakefactorMutation__
 *
 * To run a mutation, you first call `useCreateStakefactorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateStakefactorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createStakefactorMutation, { data, loading, error }] = useCreateStakefactorMutation({
 *   variables: {
 *      description: // value for 'description'
 *      name: // value for 'name'
 *      projectId: // value for 'projectId'
 *      weight: // value for 'weight'
 *   },
 * });
 */
export function useCreateStakefactorMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateStakefactorMutation, CreateStakefactorMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateStakefactorMutation, CreateStakefactorMutationVariables>(CreateStakefactorDocument, baseOptions);
      }
export type CreateStakefactorMutationHookResult = ReturnType<typeof useCreateStakefactorMutation>;
export type CreateStakefactorMutationResult = ApolloReactCommon.MutationResult<CreateStakefactorMutation>;
export type CreateStakefactorMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateStakefactorMutation, CreateStakefactorMutationVariables>;
export const DeleteConstraintDocument = gql`
    mutation DeleteConstraint($id: ID!) {
  deleteConstraint(id: $id)
}
    `;
export type DeleteConstraintMutationFn = ApolloReactCommon.MutationFunction<DeleteConstraintMutation, DeleteConstraintMutationVariables>;

/**
 * __useDeleteConstraintMutation__
 *
 * To run a mutation, you first call `useDeleteConstraintMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteConstraintMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteConstraintMutation, { data, loading, error }] = useDeleteConstraintMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteConstraintMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteConstraintMutation, DeleteConstraintMutationVariables>) {
        return ApolloReactHooks.useMutation<DeleteConstraintMutation, DeleteConstraintMutationVariables>(DeleteConstraintDocument, baseOptions);
      }
export type DeleteConstraintMutationHookResult = ReturnType<typeof useDeleteConstraintMutation>;
export type DeleteConstraintMutationResult = ApolloReactCommon.MutationResult<DeleteConstraintMutation>;
export type DeleteConstraintMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteConstraintMutation, DeleteConstraintMutationVariables>;
export const DeleteIndicatorDocument = gql`
    mutation DeleteIndicator($id: ID!) {
  deleteIndicator(id: $id)
}
    `;
export type DeleteIndicatorMutationFn = ApolloReactCommon.MutationFunction<DeleteIndicatorMutation, DeleteIndicatorMutationVariables>;

/**
 * __useDeleteIndicatorMutation__
 *
 * To run a mutation, you first call `useDeleteIndicatorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteIndicatorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteIndicatorMutation, { data, loading, error }] = useDeleteIndicatorMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteIndicatorMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteIndicatorMutation, DeleteIndicatorMutationVariables>) {
        return ApolloReactHooks.useMutation<DeleteIndicatorMutation, DeleteIndicatorMutationVariables>(DeleteIndicatorDocument, baseOptions);
      }
export type DeleteIndicatorMutationHookResult = ReturnType<typeof useDeleteIndicatorMutation>;
export type DeleteIndicatorMutationResult = ApolloReactCommon.MutationResult<DeleteIndicatorMutation>;
export type DeleteIndicatorMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteIndicatorMutation, DeleteIndicatorMutationVariables>;
export const DeleteOptionDocument = gql`
    mutation DeleteOption($id: ID!) {
  deleteOption(id: $id)
}
    `;
export type DeleteOptionMutationFn = ApolloReactCommon.MutationFunction<DeleteOptionMutation, DeleteOptionMutationVariables>;

/**
 * __useDeleteOptionMutation__
 *
 * To run a mutation, you first call `useDeleteOptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOptionMutation, { data, loading, error }] = useDeleteOptionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteOptionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteOptionMutation, DeleteOptionMutationVariables>) {
        return ApolloReactHooks.useMutation<DeleteOptionMutation, DeleteOptionMutationVariables>(DeleteOptionDocument, baseOptions);
      }
export type DeleteOptionMutationHookResult = ReturnType<typeof useDeleteOptionMutation>;
export type DeleteOptionMutationResult = ApolloReactCommon.MutationResult<DeleteOptionMutation>;
export type DeleteOptionMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteOptionMutation, DeleteOptionMutationVariables>;
export const DeleteProjectDocument = gql`
    mutation DeleteProject($id: ID!) {
  deleteProject(id: $id)
}
    `;
export type DeleteProjectMutationFn = ApolloReactCommon.MutationFunction<DeleteProjectMutation, DeleteProjectMutationVariables>;

/**
 * __useDeleteProjectMutation__
 *
 * To run a mutation, you first call `useDeleteProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProjectMutation, { data, loading, error }] = useDeleteProjectMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteProjectMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteProjectMutation, DeleteProjectMutationVariables>) {
        return ApolloReactHooks.useMutation<DeleteProjectMutation, DeleteProjectMutationVariables>(DeleteProjectDocument, baseOptions);
      }
export type DeleteProjectMutationHookResult = ReturnType<typeof useDeleteProjectMutation>;
export type DeleteProjectMutationResult = ApolloReactCommon.MutationResult<DeleteProjectMutation>;
export type DeleteProjectMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteProjectMutation, DeleteProjectMutationVariables>;
export const DeleteStakefactorDocument = gql`
    mutation DeleteStakefactor($id: ID!) {
  deleteStakefactor(id: $id)
}
    `;
export type DeleteStakefactorMutationFn = ApolloReactCommon.MutationFunction<DeleteStakefactorMutation, DeleteStakefactorMutationVariables>;

/**
 * __useDeleteStakefactorMutation__
 *
 * To run a mutation, you first call `useDeleteStakefactorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteStakefactorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteStakefactorMutation, { data, loading, error }] = useDeleteStakefactorMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteStakefactorMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteStakefactorMutation, DeleteStakefactorMutationVariables>) {
        return ApolloReactHooks.useMutation<DeleteStakefactorMutation, DeleteStakefactorMutationVariables>(DeleteStakefactorDocument, baseOptions);
      }
export type DeleteStakefactorMutationHookResult = ReturnType<typeof useDeleteStakefactorMutation>;
export type DeleteStakefactorMutationResult = ApolloReactCommon.MutationResult<DeleteStakefactorMutation>;
export type DeleteStakefactorMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteStakefactorMutation, DeleteStakefactorMutationVariables>;
export const UpdateConstraintDocument = gql`
    mutation UpdateConstraint($description: String, $id: ID!, $name: String, $weight: Int) {
  updateConstraint(description: $description, id: $id, name: $name, weight: $weight) {
    createdAt
    description
    id
    name
    weight
  }
}
    `;
export type UpdateConstraintMutationFn = ApolloReactCommon.MutationFunction<UpdateConstraintMutation, UpdateConstraintMutationVariables>;

/**
 * __useUpdateConstraintMutation__
 *
 * To run a mutation, you first call `useUpdateConstraintMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateConstraintMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateConstraintMutation, { data, loading, error }] = useUpdateConstraintMutation({
 *   variables: {
 *      description: // value for 'description'
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      weight: // value for 'weight'
 *   },
 * });
 */
export function useUpdateConstraintMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateConstraintMutation, UpdateConstraintMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateConstraintMutation, UpdateConstraintMutationVariables>(UpdateConstraintDocument, baseOptions);
      }
export type UpdateConstraintMutationHookResult = ReturnType<typeof useUpdateConstraintMutation>;
export type UpdateConstraintMutationResult = ApolloReactCommon.MutationResult<UpdateConstraintMutation>;
export type UpdateConstraintMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateConstraintMutation, UpdateConstraintMutationVariables>;
export const UpdateIndicatorDocument = gql`
    mutation UpdateIndicator($description: String, $id: ID!, $name: String, $weight: Int) {
  updateIndicator(description: $description, id: $id, name: $name, weight: $weight) {
    createdAt
    description
    id
    name
    weight
  }
}
    `;
export type UpdateIndicatorMutationFn = ApolloReactCommon.MutationFunction<UpdateIndicatorMutation, UpdateIndicatorMutationVariables>;

/**
 * __useUpdateIndicatorMutation__
 *
 * To run a mutation, you first call `useUpdateIndicatorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateIndicatorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateIndicatorMutation, { data, loading, error }] = useUpdateIndicatorMutation({
 *   variables: {
 *      description: // value for 'description'
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      weight: // value for 'weight'
 *   },
 * });
 */
export function useUpdateIndicatorMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateIndicatorMutation, UpdateIndicatorMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateIndicatorMutation, UpdateIndicatorMutationVariables>(UpdateIndicatorDocument, baseOptions);
      }
export type UpdateIndicatorMutationHookResult = ReturnType<typeof useUpdateIndicatorMutation>;
export type UpdateIndicatorMutationResult = ApolloReactCommon.MutationResult<UpdateIndicatorMutation>;
export type UpdateIndicatorMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateIndicatorMutation, UpdateIndicatorMutationVariables>;
export const UpdateOptionDocument = gql`
    mutation UpdateOption($comments: String, $description: String, $evaluation: String, $id: ID!, $isGutDecision: Boolean, $name: String) {
  updateOption(comments: $comments, description: $description, evaluation: $evaluation, id: $id, isGutDecision: $isGutDecision, name: $name) {
    comments
    constraintsEvaluations {
      description
      id
      itemId
      kind
      optionId
      value
    }
    createdAt
    description
    evaluation
    id
    indicatorsEvaluations {
      description
      id
      itemId
      kind
      optionId
      value
    }
    isGutDecision
    name
    stakefactorsEvaluations {
      description
      id
      itemId
      kind
      optionId
      value
    }
  }
}
    `;
export type UpdateOptionMutationFn = ApolloReactCommon.MutationFunction<UpdateOptionMutation, UpdateOptionMutationVariables>;

/**
 * __useUpdateOptionMutation__
 *
 * To run a mutation, you first call `useUpdateOptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOptionMutation, { data, loading, error }] = useUpdateOptionMutation({
 *   variables: {
 *      comments: // value for 'comments'
 *      description: // value for 'description'
 *      evaluation: // value for 'evaluation'
 *      id: // value for 'id'
 *      isGutDecision: // value for 'isGutDecision'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useUpdateOptionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateOptionMutation, UpdateOptionMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateOptionMutation, UpdateOptionMutationVariables>(UpdateOptionDocument, baseOptions);
      }
export type UpdateOptionMutationHookResult = ReturnType<typeof useUpdateOptionMutation>;
export type UpdateOptionMutationResult = ApolloReactCommon.MutationResult<UpdateOptionMutation>;
export type UpdateOptionMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateOptionMutation, UpdateOptionMutationVariables>;
export const UpdateOptionEvaluationDocument = gql`
    mutation UpdateOptionEvaluation($description: String, $itemId: String!, $kind: String!, $optionId: ID!, $value: Float) {
  updateOptionEvaluation(description: $description, itemId: $itemId, kind: $kind, optionId: $optionId, value: $value) {
    description
    id
    itemId
    kind
    optionId
    value
  }
}
    `;
export type UpdateOptionEvaluationMutationFn = ApolloReactCommon.MutationFunction<UpdateOptionEvaluationMutation, UpdateOptionEvaluationMutationVariables>;

/**
 * __useUpdateOptionEvaluationMutation__
 *
 * To run a mutation, you first call `useUpdateOptionEvaluationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOptionEvaluationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOptionEvaluationMutation, { data, loading, error }] = useUpdateOptionEvaluationMutation({
 *   variables: {
 *      description: // value for 'description'
 *      itemId: // value for 'itemId'
 *      kind: // value for 'kind'
 *      optionId: // value for 'optionId'
 *      value: // value for 'value'
 *   },
 * });
 */
export function useUpdateOptionEvaluationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateOptionEvaluationMutation, UpdateOptionEvaluationMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateOptionEvaluationMutation, UpdateOptionEvaluationMutationVariables>(UpdateOptionEvaluationDocument, baseOptions);
      }
export type UpdateOptionEvaluationMutationHookResult = ReturnType<typeof useUpdateOptionEvaluationMutation>;
export type UpdateOptionEvaluationMutationResult = ApolloReactCommon.MutationResult<UpdateOptionEvaluationMutation>;
export type UpdateOptionEvaluationMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateOptionEvaluationMutation, UpdateOptionEvaluationMutationVariables>;
export const UpdateProjectDocument = gql`
    mutation UpdateProject($context: String, $description: String, $experienceLevel: Int, $id: ID!, $name: String) {
  updateProject(context: $context, description: $description, experienceLevel: $experienceLevel, id: $id, name: $name) {
    constraints {
      createdAt
      description
      id
      name
      weight
    }
    context
    createdAt
    description
    experienceLevel
    id
    indicators {
      createdAt
      description
      id
      name
      weight
    }
    name
    options {
      comments
      constraintsEvaluations {
        description
        id
        itemId
        kind
        optionId
        value
      }
      createdAt
      description
      evaluation
      id
      indicatorsEvaluations {
        description
        id
        itemId
        kind
        optionId
        value
      }
      isGutDecision
      name
      stakefactorsEvaluations {
        description
        id
        itemId
        kind
        optionId
        value
      }
    }
    stakefactors {
      createdAt
      description
      id
      name
      weight
    }
  }
}
    `;
export type UpdateProjectMutationFn = ApolloReactCommon.MutationFunction<UpdateProjectMutation, UpdateProjectMutationVariables>;

/**
 * __useUpdateProjectMutation__
 *
 * To run a mutation, you first call `useUpdateProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProjectMutation, { data, loading, error }] = useUpdateProjectMutation({
 *   variables: {
 *      context: // value for 'context'
 *      description: // value for 'description'
 *      experienceLevel: // value for 'experienceLevel'
 *      id: // value for 'id'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useUpdateProjectMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateProjectMutation, UpdateProjectMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateProjectMutation, UpdateProjectMutationVariables>(UpdateProjectDocument, baseOptions);
      }
export type UpdateProjectMutationHookResult = ReturnType<typeof useUpdateProjectMutation>;
export type UpdateProjectMutationResult = ApolloReactCommon.MutationResult<UpdateProjectMutation>;
export type UpdateProjectMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateProjectMutation, UpdateProjectMutationVariables>;
export const UpdateStakefactorDocument = gql`
    mutation UpdateStakefactor($description: String, $id: ID!, $name: String, $weight: Int) {
  updateStakefactor(description: $description, id: $id, name: $name, weight: $weight) {
    createdAt
    description
    id
    name
    weight
  }
}
    `;
export type UpdateStakefactorMutationFn = ApolloReactCommon.MutationFunction<UpdateStakefactorMutation, UpdateStakefactorMutationVariables>;

/**
 * __useUpdateStakefactorMutation__
 *
 * To run a mutation, you first call `useUpdateStakefactorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStakefactorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStakefactorMutation, { data, loading, error }] = useUpdateStakefactorMutation({
 *   variables: {
 *      description: // value for 'description'
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      weight: // value for 'weight'
 *   },
 * });
 */
export function useUpdateStakefactorMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateStakefactorMutation, UpdateStakefactorMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateStakefactorMutation, UpdateStakefactorMutationVariables>(UpdateStakefactorDocument, baseOptions);
      }
export type UpdateStakefactorMutationHookResult = ReturnType<typeof useUpdateStakefactorMutation>;
export type UpdateStakefactorMutationResult = ApolloReactCommon.MutationResult<UpdateStakefactorMutation>;
export type UpdateStakefactorMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateStakefactorMutation, UpdateStakefactorMutationVariables>;